<template>
  <div class="body-box">
    <div class="Table-above">
      <!-- 表单名称 -->
      <div class="from-name">
        <p
          v-for="(item, index) in fromName"
          :key="index"
          v-show="item.Hide != 0"
        >
          <span v-if="item.required == '1'" style="color: red">*</span>
          {{ item.name }}
        </p>
        <p v-if="ruleForm.firstFlag == 0">
          <span style="color: red">*</span>到期日期：
        </p>
        <p v-if="ruleForm.firstFlag == 1">
          <span style="color: red">*</span>预计购买日期：
        </p>
        <p><span style="color: red">*</span>意向投保 ({{ realNumber }}/{{ sysConfigTotal }})：</p>
      </div>
      <!-- 表单内容 -->
      <div class="from-ipt">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <!-- 车牌 -->
          <div class="ipt-box">
            <el-form-item prop="carNum">
              <LicensePlate
                :transform="transform"
                @postFindCarNum="postFindCarNum"
                @handelClick="handelClick"
              ></LicensePlate>
            </el-form-item>
          </div>
          <!-- 车牌所在地区编码 -->
          <div class="ipt-box" v-if="carAddressCodeHide">
            <el-form-item prop="carAddressCode" style="margin-top: -2px">
              <el-select
                v-model="ruleForm.carAddressCode"
                filterable
                remote
                placeholder="系统未检测到车牌所在城市请输入车牌所在城市名称"
                :remote-method="remoteMethod"
                :loading="loading"
              >
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :value="item.cityCode"
                  :label="item.label"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <!-- 车辆性质：个人端仅支持个人 -->
          <div class="ipt-box">
            <div
              :class="ruleForm.carOwnerType == 0 ? 'Select' : 'NotSelect'"
              @click="handelNature(0)"
            ></div>
            <p class="Options">个人</p>
          </div>
          <!-- 车辆类型 -->
          <div class="ipt-box">
            <p
              v-for="(item, index) in veTypeArr"
              :key="index"
              class="Type-Options"
              :class="item.val == VeType ? 'Type-Select' : ''"
              @click="handelVeType(item.val)"
            >
              {{ item.Instructions }}
            </p>
          </div>
          <!-- 车辆类型 -->

          <div class="ipt-box">
            <el-form-item prop="carType">
              <div style="display: flex">
                <p
                  v-for="(item, index) in vehicleArr"
                  :key="index"
                  class="Type-Options"
                  :class="item.id == ruleForm.carType ? 'Type-Select' : ''"
                  @click="handelVehicle(index, item.id)"
                >
                  {{ item.name }}
                </p>
              </div>
            </el-form-item>
          </div>

          <!-- 保险种类 -->

          <div class="ipt-box-Insurance">
            <el-form-item prop="safeType" class="safe-type-form-item">
              <div style="display: flex; margin-top: -3px">
                <p
                  v-for="(item, index) in InsuranceType.slice(0, 4)"
                  :key="index"
                  class="InsuranceType"
                >
                  {{ item.name }}
                </p>

                <p v-if="InsuranceType.length > 4" class="InsuranceType">
                  +{{ InsuranceType.length - 4 }}
                </p>
                <div class="AddIcon firm-clickable" @click="handelAddInsurance"></div>

                <p class="Add-InsuranceType firm-clickable" @click="handelAddInsurance">
                  添加险种
                </p>
              </div>
            </el-form-item>
          </div>

          <!-- 是否本人 -->
          <div class="ipt-box">
            <div
              :class="ruleForm.selfFlag == '1' ? 'Select' : 'NotSelect'"
              @click="handelRadioNot(1)"
            ></div>
            <p class="Options">是</p>
            <div
              :class="ruleForm.selfFlag == '0' ? 'Select' : 'NotSelect'"
              @click="handelRadioNot(0)"
            ></div>
            <p class="Options">否</p>
          </div>

          <!-- 车主姓名 -->
          <div class="ipt-box">
            <el-form-item prop="username">
              <el-input
                v-model="ruleForm.username"
                placeholder="请输入真实姓名"
                :disabled="ownerNameDisabled"
              ></el-input>
            </el-form-item>
          </div>
          <!-- 车主身份证号 -->
          <div class="ipt-box">
            <el-form-item prop="userIdNumber">
              <el-input
                v-model="ruleForm.userIdNumber"
                placeholder="请输入真实身份证号"
                :disabled="ownerIdCardDisabled"
              ></el-input>
            </el-form-item>
          </div>
          <!-- 车主手机号 -->
          <div class="ipt-box">
            <el-form-item prop="userPhone">
              <el-input
                v-model="ruleForm.userPhone"
                placeholder="请输入真实手机号"
              ></el-input>
            </el-form-item>
          </div>
          <!-- 验证码 -->
          <div class="ipt-box">
            <el-form-item prop="authCode">
              <el-input
                v-model="ruleForm.authCode"
                placeholder="请输入验证码"
              ></el-input>
            </el-form-item>
            <p
              class="verify"
              @click="second == 60 ? handelInvoke('ruleForm') : ''"
            >
              {{
                second === totalSecond && sendNum == 0
                  ? "获取验证码"
                  : second === totalSecond && sendNum != 0
                  ? "再次获取验证码"
                  : second + `s`
              }}
            </p>
          </div>
          <!-- 是否首次投保 -->
          
          <div class="ipt-box">
            <div
              :class="ruleForm.firstFlag == '1' ? 'Select' : 'NotSelect'"
              @click="handelRadioInsure(1)"
            ></div>
            <p class="Options">是</p>
            <div
              :class="ruleForm.firstFlag == '0' ? 'Select' : 'NotSelect'"
              @click="handelRadioInsure(0)"
            ></div>
            <p class="Options">否</p>
          </div>
          <!-- 到期日期 -->
          <div class="ipt-box" v-if="ruleForm.firstFlag == 0">
            <el-form-item prop="expirationTime">
              <el-date-picker
                v-model="ruleForm.expirationTime"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd HH:mm:ss"
              >
              </el-date-picker>
            </el-form-item>
          </div>
          <!-- 预计购买日期 -->
          <div class="ipt-box" v-if="ruleForm.firstFlag == 1">
            <el-form-item prop="buyTime">
              <el-date-picker
                v-model="ruleForm.buyTime"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd HH:mm:ss"
              >
              </el-date-picker>
            </el-form-item>
          </div>
          <!-- 意向投保：本行不设 label 占位，避免与全局 el-form-item__content 样式叠加后遮挡点击 -->
          <el-form-item
            prop="safeCompanyFlag"
            label-width="0px"
            class="safe-company-flag-item"
          >
            <div class="intention" v-if="String(select) === '0'">
              <p
                class="personage"
                v-for="(item, index) in listArr"
                :key="index"
                :class="
                  item.id == ruleForm.safeCompanyFlag ? 'Select-personage' : ''
                "
                @click="handelIntention(item.id)"
              >
                {{ item.name }}
              </p>
            </div>
            <div class="intention" v-else-if="String(select) === '1'">
              <div
                class="Group-booking"
                v-for="(item, index) in listArr"
                :key="index"
                @click.stop="handelGroupBooking(item)"
                :class="item.select1 == '1' ? 'Group-booking-Select' : ''"
              >
                  {{ item.name }}
              </div>
            </div>
          </el-form-item>
        </el-form>
        <div class="submit-box"></div>
        <p
          class="submit firm-clickable"
          @click="submit('ruleForm')"
          v-if="Reservation == '1'"
          v-loading="loading1"
        >
          立即预约
        </p>
        <p
          class="submit"
          v-else
          style="background-color: #eeeeee; color: #333333"
        >
          暂未开启
        </p>
      </div>
      <!-- 价格 -->
      <div class="Price">
        <div class="Price-box">
          <div>
            <p style="color: #ffa200">预估价格</p>
            <p style="color: #fe574a">￥2000元起</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 添加险种弹窗 -->
    <Species
      :transform="transform"
      :dialogInsurance="dialogInsurance"
      @handleClose="handleClose"
      @handleUnderstand="handleUnderstand"
    ></Species>
  </div>
</template>

<script>
// 引入接口
import {
  postGetCarType, // 获取车辆类型
  postGetAllCarSafeCompany, // 获取汽车保险公司
  addPersonCarSafeActivityRegister, //参加车险活动/立即预约
} from "../../../../assets/api/indexl";
// 引入接口
import {
  postSendAuthCode, // 获取邮箱/手机验证码
  searchCity, //搜索市区
  findAddressCodeByCarNum,
  getUserInfo, // 根据用户 id 查询用户信息
} from "../../../../assets/api/index";
import LicensePlate from "./LicensePlate.vue";
import Species from "./Species.vue";
// 封装的表单验证
import { vxRule } from "../../../../../untils/FormValidation/validate-form";
export default {
  // 组件参数 接收来自父组件的数据
  props: {
    select: {},
    Reservation: {},
  },
  // 局部注册的组件
  components: { LicensePlate, Species },
  // 组件状态值
  data() {
    return {
      carAddressCodeHide: 0, //是否隐藏车牌所在地输入框
      fromName: [
        { name: "车牌号：", required: "1" },
        { name: "车牌所在地：", required: "1", Hide: 0 },
        { name: "车辆性质：" },
        { name: "车辆类型：", required: "1" },
        { name: "" },
        { name: "保险种类：", required: "1" },
        { name: "是否本人：", required: "1" },
        { name: "车主姓名：", required: "1" },
        { name: "车主身份证号：", required: "1" },
        { name: "车主手机号：", required: "1" },
        { name: "验证码：", required: "1" },
        { name: "是否首次投保：", required: "1" },
      ], //表单名列表
      veTypeArr: [
        { Instructions: "客车", val: "1" },
        { Instructions: "货车", val: "2" },
        { Instructions: "摩托车", val: "3" },
        { Instructions: "农用车", val: "4" },
        { Instructions: "其他车辆", val: "5" },
      ], // 车辆类型
      VeType: "1", // 车辆类型选择
      vehicleArr: [], // 车辆类型详情
      InsuranceType: [], // 已选择保险种类
      totalSecond: 60, // 总秒数
      second: 60, // 倒计时的秒数
      timer: null, // 定时器 id
      sendNum: "0", // 发送次数首次叫获取验证码之后叫再次发送验证码
      listArr: [],
      ruleForm: {
        activityType: "", // 0个人  / 1拼团
        carNum: "", //车牌号
        carOwnerType: "0", // 车辆性质 个人0 企业1（默认个人活动）
        carType: null, // 车辆类型
        safeType: "", // 保险种类
        selfFlag: "1", // 是否本人 1是 0否
        username: "", //车主姓名
        userIdNumber: "", // 车主身份证号
        userPhone: "", //车主手机号
        firstFlag: "1", // 是否首次 0不是
        expirationTime: "", // 到期时间
        buyTime: "", //购买时间
        safeCompanyFlag: "", // 保险公司
        authCode: "", //验证码
        evFlag: "", // 是否是新能源
        carAddressCode: "", //地址编码
      },
      vehicleListObj: {}, // 接口获取的全部车辆类型
      dialogInsurance: false, // 选择保险种类弹窗
      rules: {
        expirationTime: vxRule(true, "", ["blur", "change"], "请选择到期时间"),
        buyTime: vxRule(true, "", ["blur", "change"], "请选择预计购买时间"),
        username: vxRule(true, "UserName", ["blur", "change"], "请输入车主真实姓名"),
        userIdNumber: vxRule(true, "IdCard", ["blur", "change"], "请输入车主真实身份证号"),
        userPhone: vxRule(true, "MobileOrPhone", ["blur", "change"], "请输入车主真实手机号"),
        authCode: vxRule(true, "", ["blur", "change"], "请输入验证码"),
        safeType: vxRule(true, "", ["blur", "change"], "请选择保险种类"),
        carType: [
          {
            required: true,
            message: "请选择车辆类型",
            trigger: ["blur", "change"],
          },
        ],
        safeCompanyFlag: [
          {
            required: true,
            message: "请选择保险公司",
            trigger: ["blur", "change"],
          },
        ],
        carNum: [
          {
            required: true,
            message: "请输入车牌号",
            trigger: ["blur", "change"],
          },
          {
            required: true,
            message: "请输入正确的车牌号",
            trigger: ["blur", "change"],
            pattern:
              /^((^(京|津|沪|渝|冀|豫|云|辽|黑|湘|皖|鲁|新|苏|浙|赣|鄂|桂|甘|晋|蒙|陕|吉|闽|贵|粤|青|藏|川|宁|琼)[A-Z]{1}[A-Z0-9]{5}[A-Z0-9挂学警港澳试超使领北南军海空外]{1}$)|(^(京|津|沪|渝|冀|豫|云|辽|黑|湘|皖|鲁|新|苏|浙|赣|鄂|桂|甘|晋|蒙|陕|吉|闽|贵|粤|青|藏|川|宁|琼)[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳试超使领北南军海空外]{1}$))/,
          },
        ],
        carAddressCode: [
          {
            required: true,
            message: "请输入车牌所在地编码",
            trigger: ["blur", "change"],
          },
        ],
      }, // 表单验证
      transform: 1, // 传给子组件的数据，在子组件监听只要变化就清空车牌/保险种类
      intentionIdArr: [], //意向投保数组
      options: [],
      value: [],
      list: [],
      loading: false, // 加载....
      loading1: false,
      LicensePlate0: "",
      LicensePlate1: "",
      realNumber: 0, // 活动名额
      sysConfigTotal: 0, // 活动人数
      /** 姓名、身份证是否为接口/账号回填，仅此时禁用编辑（避免用户自填时被 disabled 截断） */
      ownerNameLockedFromApi: false,
      ownerIdCardLockedFromApi: false,
    };
  },
  computed: {
    /** 是本人且姓名为账号/接口回填时不可改 */
    ownerNameDisabled() {
      if (String(this.ruleForm.selfFlag) !== "1") return false;
      return (
        this.ownerNameLockedFromApi &&
        String(this.ruleForm.username || "").trim() !== ""
      );
    },
    /** 是本人且身份证为账号/接口回填时不可改 */
    ownerIdCardDisabled() {
      if (String(this.ruleForm.selfFlag) !== "1") return false;
      return (
        this.ownerIdCardLockedFromApi &&
        String(this.ruleForm.userIdNumber || "").trim() !== ""
      );
    },
  },
  watch: {
    // 监听
    select: {
      handler(newss, old) {
        this.Finished();
        // 保险公司数组中添加的select全部重置
        this.postGetAllCarSafeCompany();
      },
      immediate: false,
    },
  },
  // 组件初始化
  created() {
    // 获取车辆类型
    this.postGetCarType();
    // 获取汽车保险公司
    this.postGetAllCarSafeCompany();
    // 车主姓名/身份证/手机号：与接口一致，使用 getUserInfo（身份证仅 idCardAudit===3 回显）
    this.fetchUserInfoForForm();
  },
  // 组件实例挂载完毕
  mounted() {},
  //销毁事件
  destroyed() {
    clearInterval(this.timer);
    this.timer = null; // 重置定时器 id
    this.second = this.totalSecond; // 归位
  },
  // 组件方法
  methods: {
    resetOwnerFieldLocks() {
      this.ownerNameLockedFromApi = false;
      this.ownerIdCardLockedFromApi = false;
    },
    // idCardAudit === 3 表示身份已认证，才允许回显姓名/身份证号
    isIdCardAudited(u) {
      if (!u || typeof u !== "object") return false;
      const audit = u.idCardAudit;
      return audit === 3 || audit === "3" || Number(audit) === 3;
    },
    applyUserInfoToForm(u) {
      if (!u || typeof u !== "object") return;
      const auditOk = this.isIdCardAudited(u);
      const name = u.username ?? u.userName ?? u.realName ?? "";
      const idCard = u.idCard ?? u.idNumber ?? u.identityCard ?? "";
      const phone = u.phone ?? u.mobile ?? "";

      if (auditOk) {
        if (name !== undefined && name !== null && String(name).trim() !== "") {
          this.ruleForm.username = String(name).trim();
          this.ownerNameLockedFromApi = true;
        }
        if (
          idCard !== undefined &&
          idCard !== null &&
          String(idCard).trim() !== ""
        ) {
          this.ruleForm.userIdNumber = String(idCard).trim();
          this.ownerIdCardLockedFromApi = true;
        }
      } else {
        this.ruleForm.username = "";
        this.ruleForm.userIdNumber = "";
        this.ownerNameLockedFromApi = false;
        this.ownerIdCardLockedFromApi = false;
      }

      if (phone !== undefined && phone !== null && String(phone).trim() !== "") {
        this.ruleForm.userPhone = String(phone).trim();
      }
    },
    async fetchUserInfoForForm() {
      const storeUser = this.$store.getters.getUser || {};
      const userId = storeUser.id;
      if (userId == null || userId === "") {
        this.applyUserInfoToForm(storeUser);
        return;
      }
      try {
        const res = await getUserInfo({ data: userId });
        if (res && res.code === 0 && res.data) {
          this.applyUserInfoToForm(res.data);
        } else {
          this.applyUserInfoToForm(storeUser);
        }
      } catch (e) {
        this.applyUserInfoToForm(storeUser);
      }
    },
    //  远程搜索
    async remoteMethod(query) {
      var data = {};
      data.data = {
        keyword: query,
      };

      if (data.data.keyword !== "") {
        this.loading = true; // 提前开启 loading
        try {
          const res = await searchCity(data);

          // 安全校验：确保 res.data.list 是一个数组
          const list = res?.data?.data.list || [];
          this.list = list.map((item) => ({
            value: `${item.provinceName}-${item.cityName}`,
            label: `${item.cityName}`,
            id: `${item.provinceCode}-${item.cityCode}`,
            cityCode: String(
              item.cityCode != null && item.cityCode !== "" ? item.cityCode : ""
            ).trim(),
          }));

          // 接口返回后，立即进行过滤并更新 options
          this.options = this.list.filter((item) => {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
          });
        } catch (error) {
          console.error("获取城市数据失败:", error);
          this.list = [];
          this.options = [];
        } finally {
          this.loading = false; // 无论成功失败，都关闭 loading
        }
      } else {
        this.list = [];
        this.options = [];
      }
    },
    async Finished(skipFetchUser = false) {
      this.resetOwnerFieldLocks();
      const savedIdentity = skipFetchUser
        ? {
            username: this.ruleForm.username,
            userPhone: this.ruleForm.userPhone,
            userIdNumber: this.ruleForm.userIdNumber,
          }
        : null;
      // 提交成功 / 切换活动：表单与相关展示恢复初始
      this.ruleForm.activityType = "";
      this.ruleForm.carNum = "";
      this.ruleForm.carOwnerType = "0";
      this.ruleForm.carType = null;
      this.ruleForm.safeType = "";
      this.ruleForm.selfFlag = "1";
      this.ruleForm.firstFlag = "1";
      this.$set(this.ruleForm, "expirationTime", "");
      this.$set(this.ruleForm, "buyTime", "");
      this.ruleForm.safeCompanyFlag = "";
      this.ruleForm.authCode = "";
      this.ruleForm.evFlag = "";
      if (!savedIdentity) {
        this.ruleForm.userIdNumber = "";
        this.ruleForm.username = "";
        this.ruleForm.userPhone = "";
      } else {
        this.ruleForm.username = savedIdentity.username;
        this.ruleForm.userPhone = savedIdentity.userPhone;
        this.ruleForm.userIdNumber = savedIdentity.userIdNumber;
      }
      this.ruleForm.carAddressCode = "";
      this.carAddressCodeHide = 0;
      if (this.fromName[1]) {
        this.fromName[1].Hide = 0;
      }
      this.LicensePlate0 = "";
      this.LicensePlate1 = "";
      this.VeType = "1";
      if (this.vehicleListObj && this.vehicleListObj.客车) {
        this.vehicleArr = this.vehicleListObj.客车;
      }
      this.options = [];
      this.list = [];
      this.dialogInsurance = false;
      // 已选择的保险种类 展示清空
      this.InsuranceType = [];
      // 拼团中的意向投保 清空
      this.intentionIdArr = [];
      // 改变值 传给子组件，子组件监听到值改变 清空车牌/保险种类
      this.transform++;
      setTimeout(() => {
        this.$refs.ruleForm.clearValidate();
      }, 10);
      clearInterval(this.timer);
      this.timer = null; // 重置定时器 id
      this.second = this.totalSecond; // 归位
      this.sendNum = "0";
      await this.fetchUserInfoForForm();
      if (skipFetchUser) {
        await this.postGetAllCarSafeCompany();
      }
    },
    postFindCarNum() {
      setTimeout(() => {
        this.$refs.ruleForm.clearValidate();
      }, 10);
    },
    // -------------------------------车牌号-----------------------
    // 判断是否是新能源不严谨 需要继续加判断 因为最后一个框的新字会被清空
    handelClick(val) {
      // console.log(val, "接收的数据");
      var arr = [];
      var str = "";
      if (
        val[0].val != this.LicensePlate0 ||
        val[1].val != this.LicensePlate1
      ) {
        if (val[0].val != "" && val[1].val != "") {
          const result = String(val[0].val || "") + String(val[1].val || "");
          // 车牌地区输入有变化  调用接口判断是否需要输入车牌所在地编码
          findAddressCodeByCarNum({ data: result }).then((res) => {
            this.ruleForm.carAddressCode = "";
            if (res.data.data == null || res.data.data == "") {
              this.carAddressCodeHide = 1;
              this.fromName[1].Hide = 1;
            } else {
              this.carAddressCodeHide = 0;
              this.fromName[1].Hide = 0;
            }
          });
        }
      }
      this.LicensePlate0 = val[0].val;
      this.LicensePlate1 = val[1].val;
      // 循环取出放入arr数组中
      for (var i in val) {
        arr[i] = val[i].val;
      }
      // 查看最后一项是新/数字字母  是新说明是七位数的车牌新的input没有输入 最后一位不是新说明是八位数车牌是新能源车
      if (arr[arr.length - 1] == "新" || arr[arr.length - 1] == "") {
        // 最后一位是新删除最后一位
        arr.pop();
        // 车牌类型
        this.ruleForm.evFlag = "0";
      } else {
        // 车牌类型
        this.ruleForm.evFlag = "1";
      }
      // 数组转字符串
      str = arr.toString();
      // 去掉中间逗号
      var str1 = str.split(",");
      // 字符串重新拼接
      var res = str1.join("");
      // 得出车牌
      this.ruleForm.carNum = res;

      this.$refs.ruleForm?.validateField("carNum");
    },
    // -----------------添加险种弹窗确认（将选择添加的险种加入保险种类展示）---------------
    handleUnderstand(val, valId) {
      console.log(val, valId);
      // 接收子组件传过来的 已选择保险种类的id数组
      this.ruleForm.safeType = valId.toString();
      console.log(this.ruleForm.safeType);
      // 保险种类已选中展示数据
      this.InsuranceType = val;
      // 关闭弹窗
      this.dialogInsurance = !this.dialogInsurance;
      this.$refs.ruleForm?.validateField("safeType");
    },
    // ---------------------------关闭添加险种弹窗--------------------
    handleClose() {
      this.dialogInsurance = !this.dialogInsurance;
    },
    // ------------------------添加险种按钮----------------------
    handelAddInsurance() {
      this.dialogInsurance = true;
    },
    // 调用 ---------------------获取车辆类型接口---------------------
    postGetCarType() {
      postGetCarType().then((res) => {
        if (res.code == 0) {
          this.vehicleListObj = res.data;
          this.vehicleArr = this.vehicleListObj['客车'];
          console.log(this.vehicleArr);
          
          console.log(this.vehicleArr);
        }
      });
    },

    // ----------------------获取汽车保险公司---------------
    async postGetAllCarSafeCompany() {
      const res = await postGetAllCarSafeCompany({ data: this.select });
      if (res.code == 0) {
        const raw = res.data && Array.isArray(res.data.list) ? res.data.list : [];
        // 拼团多选依赖 select1；接口若无该字段或非字符串，用新对象 + 归一化保证可点、可选中态可更新
        this.listArr = raw.map((row) => {
          const select1 =
            row.select1 === undefined || row.select1 === null || row.select1 === ""
              ? "0"
              : String(row.select1);
          return { ...row, select1 };
        });
        this.realNumber = res.data.realNumber;
        this.sysConfigTotal = res.data.sysConfigTotal;
      } else {
        // this.$tool.PromptBox("error", res.msg);
      }
    },
    // ---------------------------- 点击发送验证码 接口 -----------------------
    handelInvoke(formName) {
      // 单独查看手机号是否校验成功
      this.$refs[formName].validateField("userPhone", (errMsg) => {
        if (errMsg) {
          console.log("校验未通过");
        } else {
          console.log("校验通过");
          // 获取验证码接口
          var data = {};
          data.data = {
            mobile: this.ruleForm.userPhone,
            type: 0,
            authCodeBusiness: "13",
          };
          postSendAuthCode(data).then((res) => {
            if (res.code == 0) {
              this.Countdown();
              this.$tool.PromptBox("success", "验证码已发送");
            } else {
              // 验证码发送失败
              // this.$tool.PromptBox("error", "验证码发送失败");
            }
          });
        }
      });
    },
    // -------------------------------- 发送验证码倒计时----------------------
    Countdown() {
      this.textCode = false;
      var that = this;
      setTimeout(function () {
        that.sendNum++;
        console.log(that.sendNum);
        // 时间间隔
      }, 1000);

      // 当前目前没有定时器开着，且 totalSecond 和 second 一致 (秒数归位) 才可以倒计时
      if (!this.timer && this.second === this.totalSecond) {
        // 开启倒计时
        this.timer = setInterval(() => {
          this.second--;
          if (this.second <= 0) {
            clearInterval(this.timer);
            this.timer = null; // 重置定时器 id
            this.second = this.totalSecond; // 归位
          }
        }, 1000);
      }
    },
    // --------------------------车辆详情选择----------------
    handelVehicle(num, id) {
      // 选中车辆类型的id
      this.ruleForm.carType = id;
      this.$refs.ruleForm?.validateField("carType");
    },
    // -----------------是否首次投保-------------------
    handelRadioInsure(num) {
      this.ruleForm.firstFlag = num;
      this.$set(this.ruleForm, "expirationTime", "");
      this.$set(this.ruleForm, "buyTime", "");
      this.$nextTick(() => {
        this.$refs.ruleForm?.clearValidate(["expirationTime", "buyTime"]);
      });
    },
    // -------------------------车辆性质选择-------------------
    handelNature(num) {
      this.ruleForm.carOwnerType = num;
    },
    // --------------------车辆类型选择----------------------------
    // veTypeArr 的 val 与接口 data 分类键一致：客车/货车/摩托车/农用车/其他
    handelVeType(num) {
      const v = String(num);
      const valToKey = {
        "1": "客车",
        "2": "货车",
        "3": "摩托车",
        "4": "农用车",
        "5": "其他",
      };
      const key = valToKey[v];
      if (!key) {
        this.vehicleArr = [];
      } else {
        const list = this.vehicleListObj && this.vehicleListObj[key];
        if (Array.isArray(list) && list.length > 0) {
          this.vehicleArr = list;
        } else if (key === "其他") {
          this.vehicleArr = [{ name: "其他", id: 999 }];
        } else {
          this.vehicleArr = [];
        }
      }
      this.ruleForm.carType = null;
      this.VeType = v;
    },
    // ---------------------------是否本人-------------------------
    handelRadioNot(num) {
      // selfFlag：1本人 0非本人；点击否时清空车主信息
      this.ruleForm.selfFlag = String(num);
      if (num == 0) {
        this.resetOwnerFieldLocks();
        this.ruleForm.username = "";
        this.ruleForm.userIdNumber = "";
        this.ruleForm.userPhone = "";
      } else {
        // 点击是本人：走 getUserInfo，姓名/身份证仅 idCardAudit === 3 时回显
        this.resetOwnerFieldLocks();
        this.fetchUserInfoForForm();
      }
    },
    // ---------------------------意向投保-------------------
    handelIntention(num) {
      this.ruleForm.safeCompanyFlag = num;
      this.$refs.ruleForm?.validateField("safeCompanyFlag");
    },
    // --------------------------拼团意向投保---------------------
    handelGroupBooking(item) {
      // 拼团活动中点击选择 意向投保公司
      const selected = item.select1 == "1" || item.select1 === 1;
      if (selected) {
        this.$set(item, "select1", "0");
        for (let i = this.intentionIdArr.length - 1; i >= 0; i--) {
          if (item.id == this.intentionIdArr[i]) {
            this.intentionIdArr.splice(i, 1);
          }
        }
      } else {
        this.$set(item, "select1", "1");
        this.intentionIdArr.push(item.id);
      }
      this.ruleForm.safeCompanyFlag = this.intentionIdArr.join(",");
      this.$refs.ruleForm?.validateField("safeCompanyFlag");
    },
    // ------------------------------立即预约-------------------------
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        this.loading1 = true;
        if (valid) {
          const rf = this.ruleForm;
          const payload = { ...rf };
          if (payload.carAddressCode !== "" && payload.carAddressCode != null) {
            const parts = String(payload.carAddressCode).split("-");
            payload.carAddressCode = parts[parts.length - 1];
          }
          if (payload.firstFlag == "1" || payload.firstFlag === 1) {
            delete payload.expirationTime;
          } else {
            delete payload.buyTime;
          }
          payload.safeType = (rf.safeType || "") + ",";
          payload.activityType = this.select;
          payload.safeCompanyFlag = (rf.safeCompanyFlag || "") + ",";
          var data = {};
          data.data = payload;
          // 调用立即预约接口
          addPersonCarSafeActivityRegister(data).then((res) => {
            if (res.code == 0) {
              this.Finished(true);
              this.loading1 = false;
              this.$tool.PromptBox("success", "预约成功");
            } else {
              clearInterval(this.timer);
              this.timer = null; // 重置定时器 id
              this.second = this.totalSecond; // 归位
              this.sendNum = "0";
              this.ruleForm.authCode = "";
              this.loading1 = false;
              // this.$tool.PromptBox("error", res.msg);
            }
          });
        } else {
          this.loading1 = false;
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
/deep/.el-form-item {
  margin-bottom: 0px;
}
/deep/.el-date-editor {
  position: relative !important;
}
/deep/.el-form-item__content {
  margin-left: 0 !important;
}
/* 意向投保行：避免内容区与 label 叠层导致拼团选项点不到 */
/deep/.safe-company-flag-item.el-form-item .el-form-item__content {
  position: relative;
  z-index: 12;
  pointer-events: auto;
  overflow: visible;
}
/deep/.safe-type-form-item.el-form-item .el-form-item__error {
  white-space: nowrap !important;
  word-break: keep-all !important;
  word-wrap: normal !important;
  overflow-wrap: normal !important;
}
/deep/.el-input {
  width: 350px !important;
}
// 时间选择 icon 样式
/deep/.el-icon-date {
  font-size: 20px !important;
  // margin-top: -2px;
}
// 输入框样式
/deep/.el-input__inner {
  height: 35px !important;
  line-height: 35px !important;
  font-size: 12px;
  border: 1px solid #409eff ;
}
.body-box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  // 上表
  .Table-above {
    width: 100%;
    min-height: 200px;
    display: flex;
    position: relative;
    z-index: 0;
  }
  // 表单名
  .from-name {
    min-width: 160px;
    height: 100%;
    font-family: PingFangSC-Medium;
    font-size: 12px;
    color: #333333;
    text-align: right;
    font-weight: 400;
    p {
      height: 35px;
      font-family: PingFangSC-Medium;
      font-size: 12px;
      color: #333333;
      text-align: right;
      line-height: 35px;
      font-weight: 400;
      margin-bottom: 24.5px;
    }
  }
  // 表单内容（保证在价格装饰层之上，可点击）
  .from-ipt {
    min-width: 350px;
    height: 100%;
    position: relative;
    z-index: 9;
    // 立即预约
    .submit-box {
      width: 100%;
      height: 60px;
      position: relative;
    }
    .submit {
      width: 120px;
      height: 40px;
      line-height: 40px;
      background: #409eff ;
      border-radius: 5px;
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #ffffff;
      text-align: center;
      font-weight: 400;
      position: absolute;
      right: 0px;
      bottom: 0;
      cursor: pointer;
    }
    // 获取验证码按钮
    .verify {
      position: absolute;
      top: 4px;
      right: 15px;
      font-size: 12px;
      color: #409eff ;
      cursor: pointer;
    }
    .ipt-box-Insurance {
      width: 780px;
      min-height: 35px;
      line-height: 35px;
      display: flex;
      flex-wrap: wrap;
      position: relative;
      margin-bottom: 20px;
      /deep/ .safe-type-form-item.el-form-item {
        width: 100% !important;
        max-width: 100%;
      }
      // 车辆保险种类已选择
      .InsuranceType {
        min-width: 90px;
        padding-left: 5px;
        padding-right: 5px;
        height: 33px;
        line-height: 33px;
        background: rgba(97, 144, 232, 0.27);
        border: 1px solid #409eff ;
        border-radius: 5px;
        font-size: 12px;
        color: #409eff ;
        text-align: center;
        margin-right: 15px;
        cursor: pointer;
      }
      // 保险种类 添加
      .AddIcon {
        width: 18px;
        height: 18px;
        background-image: url("../../../../assets/imgs/tianjia@3x.svg");
        background-size: 100% 100%;
        margin: auto 0;
        z-index: 99;
        cursor: pointer;
      }
      .Add-InsuranceType {
        margin-left: 5px;
        font-size: 12px;
        color: #333333;
        z-index: 99;
        cursor: pointer;
      }
    }
    .ipt-box {
      width: 350px;
      height: 35px;
      line-height: 35px;
      margin-bottom: 25px;
      display: flex;
      position: relative;
      // 单选选中/未选中样式
      // 单选 选中
      .Select {
        width: 18px;
        height: 18px;
        background-image: url("../../../../assets/imgs/gouxuan@3x.svg");
        background-size: 100% 100%;
        margin: auto 0;
        cursor: pointer;
      }
      // 单选 未选中
      .NotSelect {
        width: 18px;
        height: 18px;
        background-image: url("../../../../assets/imgs/weigouxuan@3x.svg");
        background-size: 100% 100%;
        margin: auto 0;
        cursor: pointer;
      }
      // 单选 选项
      .Options {
        font-family: PingFangSC-Medium;
        font-size: 14px;
        color: #333333;
        font-weight: 400;
        margin-left: 5px;
        margin-right: 40px;
              cursor: pointer;
}
      // 车辆类型 选择
      // 未选中
      .Type-Options {
        min-width: 110px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        height: 33px;
        line-height: 33px;
        background: #ffffff;
        border: 1px solid #409eff ;
        border-radius: 5px;
        font-size: 12px;
        color: #409eff ;
        text-align: center;
        margin-right: 15px;
        cursor: pointer;
      }
      // 车辆类型选中
      .Type-Select {
        background: rgba(97, 144, 232, 0.27);
        border: 1px solid #409eff ;
              cursor: pointer;
}
    }
    // 意向投保（拼团选项需在价格装饰层之上）
    .intention {
      width: 750px;
      min-height: 100px;
      display: flex;
      flex-wrap: wrap;
      position: relative;
      z-index: 2;

      // 个人活动
      .personage {
        min-width: 90px;
        height: 35px;
        line-height: 35px;
        background: #ffffff;
        border: 1px solid #409eff ;
        border-radius: 5px;
        font-family: PingFangSC-Medium;
        font-size: 12px;
        color: #409eff ;
        text-align: center;
        font-weight: 400;
        margin-right: 10px;
        cursor: pointer;
      }
      .Select-personage {
        background: rgba(97, 144, 232, 0.27);
        border: 1px solid #409eff ;
      }
      // 拼团活动
      .Group-booking {
        position: relative;
        z-index: 2;
        pointer-events: auto;
        min-width: 90px;
        height: 35px;
        line-height: 35px;
        background: #ffffff;
        border: 1px solid #409eff ;
        border-radius: 5px;
        font-family: PingFangSC-Medium;
        font-size: 12px;
        color: #409eff ;
        text-align: center;
        font-weight: 400;
        margin-right: 10px;
        cursor: pointer;
      }
      .Group-booking-Select {
        background: rgba(97, 144, 232, 0.27);
        border: 1px solid #409eff ;
      }
    }
  }
  // 价格：仅装饰展示，不参与点击；且不要用 height:100% 相对外层撑满挡住表单
  .Price {
    width: 300px;
    height: auto;
    max-height: 280px;
    margin: auto;
    position: absolute;
    right: 0;
    top: 0;
    display: flex;
    z-index: 0;
    pointer-events: none !important;
    &,
    & * {
      pointer-events: none !important;
    }
    .Price-box {
      width: 300px;
      height: 250px;
      background-image: url("../../../../assets/imgs/jiaqianbiao@3x.svg");
      background-size: 100% 100%;
      margin: auto;
      display: flex;
      flex-direction: column;
      div {
        height: 100px;
        margin: auto;
        display: flex;
        flex-direction: column;
      }
      p {
        margin: auto;
      }
    }
  }
}
</style>
